import { FC, memo } from 'react';
import AddIcon from '@icons/add_circle_icon--white.svg?component';
import { Button } from '@components/Core/Button';
import { IAddEntityButtonProps } from './types';

export const AddEntityButton: FC<IAddEntityButtonProps> = memo(
  ({ onClick, text, styleProp, textStyleProps, disabled = false, icon }) => {
    return (
      <Button
        text={text}
        onClick={onClick}
        icon={icon || <AddIcon width={20} height={20} className="md:hidden" />}
        styleProp={`max-w-[153px] max-md:max-w-[52px] ${styleProp}`}
        textStyleProps={`max-md:hidden ${textStyleProps}`}
        disabled={disabled}
      />
    );
  }
);
